import Vue from "vue";


Vue.filter('currencyFormat', function (value) {
    if (!value) value = 0;
    value = parseFloat(value);
    return (new Intl.NumberFormat(
        typeof lang !== "undefined" ? lang : 'de',
        {
            style: 'currency',
            currency: 'EUR'
        })
        .format(value))
})


// WEBPACK FOOTER //
// ./src/components/globals/filters.js